// Fragment "catalogue editing" — the practitioner-side screens that create and change
// what the practice sells (gift cards; the pathway builder has its own fragment,
// ./pathways.js).
//
// Convention (same as every sibling fragment): flat dotted keys, a value in all three
// languages, never empty. English is BASE_LANG and the fallback; FR is what most of
// today's practitioners read.
export default {
  fr: {
    // Gift cards — the third outcome the list has to be able to state: not "here they
    // are", not "you have none", but "they could not be loaded".
    "gift.loadFailed": "Vos cartes-cadeaux n'ont pas pu être chargées. C'est un problème de chargement — aucune carte n'a été supprimée.",
    "gift.sessionExpired": "Votre session a expiré. Reconnectez-vous pour émettre et consulter vos cartes-cadeaux.",
    "gift.retry": "Réessayer",
    "gift.signInAgain": "Se reconnecter",
  },
  en: {
    "gift.loadFailed": "Your gift cards could not be loaded. This is a loading problem — no card has been deleted.",
    "gift.sessionExpired": "Your session has expired. Sign in again to issue and view your gift cards.",
    "gift.retry": "Try again",
    "gift.signInAgain": "Sign in again",
  },
  es: {
    "gift.loadFailed": "No se pudieron cargar sus tarjetas regalo. Es un problema de carga: no se ha eliminado ninguna tarjeta.",
    "gift.sessionExpired": "Su sesión ha caducado. Vuelva a iniciar sesión para emitir y ver sus tarjetas regalo.",
    "gift.retry": "Reintentar",
    "gift.signInAgain": "Volver a iniciar sesión",
  },
};
